import { ErrorHandler, inject, Injectable } from '@angular/core';
import { PosthogService } from '@hp-core/services/posthog.service';

@Injectable()
export class PosthogErrorHandler implements ErrorHandler {
  private readonly posthog = inject(PosthogService);

  handleError(error: unknown): void {
    this.posthog.captureException(error);
    // Mantiene el comportamiento por defecto de Angular (log en consola)
    console.error(error);
  }
}
